import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/components/pivotbox/metaPixel";

/**
 * ScrollToTop — forces window scroll to (0,0) on every route change,
 * and fires a Meta Pixel PageView for SPA navigations (the base snippet
 * only fires once on initial load).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
